<template>
  <div>
    <div class="class-item blue" v-if="tutoring.status == 1">
      <div class="class-item-content">
        <h4 class="d-flex align-items-center">{{ tutoring.subscribe_from | convertUnitToTime('ddd') }} -
          {{ tutoring.subscribe_from | convertUnitToTime('DD/MM/YYYY') }} -
          {{ tutoring.time_start | convertUnitToTime('HH:mm') }} {{ $t('to') }}
          {{ tutoring.time_end | convertUnitToTime('HH:mm') }}
          <template v-if="tutoring.is_live == 1">
            <span class="live-class-dot ms-auto"></span><span class="live-class-text">{{ $t('live_now') }}</span>
          </template>
        </h4>

        <div class="d-flex">
          <div class="class-item-col-1">
            <div class="desc"><b>{{ $t('class') }} </b> <span class="underline">{{ tutoring.class_name }}</span></div>
            <div class="desc"><b>{{ $t('subject') }} </b> <span class="underline">{{ tutoring.subject }}</span></div>
            <div class="desc"><b>{{ $t('teacher') }} </b> <span class="underline">{{ tutoring.teacher }}</span></div>
          </div>
          <div class="class-item-col-2 ms-auto mt-auto flex-grow-0 flex-shrink-1">
            <button class="btn btn-register-class" style="padding: 8px 25px;" v-if="timeRemaining < 24">{{ $t('class_open_in') }}
              <countdown :key="tutoring.id" :time="tutoring.time_start" @finished="countdownFinished"/>
            </button>
            <button class="btn btn-register-class" style="padding: 8px 25px;" v-else>{{ $t('class_coming_up') }}
              <countdown-live-class :key="tutoring.id" :time="tutoring.time_start" @finished="countdownFinished2"/>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="class-item" v-else-if="tutoring.status == 2">
      <div class="class-item-content">
        <h4 class="d-flex align-items-center">{{ tutoring.subscribe_from | convertUnitToTime('ddd') }} -
          {{ tutoring.subscribe_from | convertUnitToTime('DD/MM/YYYY') }} -
          {{ tutoring.time_start | convertUnitToTime('HH:mm') }} {{ $t('to') }}
          {{ tutoring.time_end | convertUnitToTime('HH:mm') }}
          <template v-if="tutoring.is_live == 1">
            <span class="live-class-dot ms-auto"></span><span class="live-class-text">{{ $t('live_now') }}</span>
          </template>
        </h4>

        <div class="d-flex">
          <div class="class-item-col-1">
            <div class="desc"><b>{{ $t('class') }}</b> <span class="underline">{{ tutoring.class_name }}</span></div>
            <div class="desc"><b>{{ $t('subject') }}</b> <span class="underline">{{ tutoring.subject }}</span></div>
            <div class="desc"><b>{{ $t('teacher') }}</b> <span class="underline">{{ tutoring.teacher }}</span></div>

          </div>
          <div class="class-item-col-2 ms-auto mt-auto flex-grow-0 flex-shrink-1">
            <a v-if="tutoring.join_url" :href="tutoring.join_url" target="_blank">
              <button class="btn btn-join-class" style="padding: 8px 25px;  width: 180px">{{ $t('join_to_class') }}
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="class-item gray" v-else-if="tutoring.status == 4">
      <div class="class-item-content">
        <h4 class="d-flex align-items-center">{{ tutoring.subscribe_from | convertUnitToTime('ddd') }} -
          {{ tutoring.subscribe_from | convertUnitToTime('DD/MM/YYYY') }} -
          {{ tutoring.time_start | convertUnitToTime('HH:mm') }} {{ $t('to') }}
          {{ tutoring.time_end | convertUnitToTime('HH:mm') }}
          <span class="ms-auto"></span><span class="live-class-text-finish">{{ $t('finished_classes') }}</span>
        </h4>

        <div class="d-flex">
          <div class="class-item-col-1">
            <div class="desc"><b>{{ $t('class') }}</b> <span class="underline">{{ tutoring.class_name }}</span></div>
            <div class="desc"><b>{{ $t('subject') }}</b> <span class="underline">{{ tutoring.subject }}</span></div>
            <div class="desc"><b>{{ $t('teacher') }}</b> <span class="underline">{{ tutoring.teacher }}</span></div>
          </div>
          <div class="class-item-col-2 ms-auto mt-auto flex-grow-0 flex-shrink-1">
            <!--                        <button class="btn btn-class-finish"  style="padding: 8px 25px; width: 180px">{{$t('finished_classes')}}</button>-->
            <button class="ito-btn ito-btn-primary" @click="showComment">{{ $t('btn_view_liveclass_comment') }}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" :id="`comment-modal-${tutoring.id}`" tabindex="-1" aria-labelledby="notificationLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered  modal-xl modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header border-0">
            <h5 class="modal-title popup-title flex-fill text-center" id="notificationLabel"></h5>
            <button type="button" class="close-popup" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body ">
            <div>
              <h5 class="text-center title-comment">{{ $t('daily_comment_title') }}</h5>

              <template v-if="comment.content">
                <div class="content-comment"><strong>{{ comment.lesson_name }}: </strong><span
                    v-text="comment.study_time"></span><br/>
                  <strong>{{ $t('teacher') }}: </strong><span v-text="comment.teacher_name"></span><br/><br/>
                  <strong>{{ $t('daily_comment_content') }}: </strong><br><span v-html="comment.content"></span>
                </div>
              </template>
              <template v-else>
                <div class="content-no-comment">
                  <span>{{ $t('daily_comment_content_null') }}</span>
                </div>
              </template>

            </div>


            <div style=" margin-bottom: 10px">

              <h5 class="text-center title-comment">{{ $t('liveclass_recorded_video') }}</h5>
              <template v-if="liveUrl">
                <div class="content-comment">
                  <iframe :src="liveUrl" frameborder="0" width="100%" height="400px"></iframe>
                </div>

                <div style="text-align: center">
                  <a :href="liveUrl" target="_blank" class="ito-btn ito-btn-primary"
                     style="margin:0 auto;">{{ $t('btn_view_fullscreen') }}</a>
                </div>
              </template>
              <template v-else>
                <div class="content-no-comment"><span>{{ $t('liveclass_recorded_video_null') }}</span></div>
              </template>
            </div>

          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {mapGetters} from 'vuex'
// import axios from "axios";
// import {getTutorings, tutoringSubscribe} from "../../models/tutoring";
// import { joinLiveClass } from "../../models/tutoring";
// import { convertSecondToText } from "../../utils/utils";
import Countdown from '../element/Countdown.vue';
import CountdownLiveClass from '../element/CountdownLiveClass.vue';
import { getLanguage } from '../../utils/utils'
import axios from "axios";

export default {
  components: {CountdownLiveClass, Countdown},
  name: "TutoringItem",

  props: ['tutoring'],

  computed: {
    ...mapGetters([
      'user_info'
    ], () => {
      if (this.user_info) {
        return this.user_info
      }
      return {
        gem: 0
      }
    })
  },
  data() {
    return {
      register_time_start: "",
      comment: {
        teacher_name: "",
        lesson_name: "",
        content: "",
        study_time: ""
      },
      timeRemaining: 0,
      liveUrl: ""
    };
  },
  created() {

    //this.tutoring.status = 1;
    const timeCurrent = Math.floor(Date.now() / 1000);
    this.timeRemaining = Math.floor((this.tutoring.time_start -  timeCurrent) / 3600);

    this.countdown = this.tutoring.time_end;
  },
  methods: {
    async showComment() {
      let self = this;
      const params = {
        class_id: this.$store.state.user_info.eco_class_id,
        student_id: this.$store.state.user_info.eco_user_id
      }
      const res = await axios.get(`${process.env.VUE_APP_ECO_URL}/api_eco.php/getCommentByClass`, { params })
      let studyDate = moment.unix(self.tutoring.subscribe_from).format('YYYY-MM-DD');
      let startTime = moment.unix(self.tutoring.subscribe_from).format('HH:mm');
      let endTime = moment.unix(self.tutoring.time_end).format('HH:mm');
      let lang = getLanguage();

      if (res.status == 200) {
        let data = res.data.data;
        data.forEach(function (e) {
          if (studyDate == e.study_date && startTime == e.start_hour && endTime == e.end_hour) {
            let item = e;
            self.comment.teacher_name = item.teacher_name;
            self.comment.lesson_name = item.lesson_name;

            if(lang == "vi"){
              self.comment.content = item.commentVI;
            }else{
              self.comment.content = item.comment;
            }
            self.comment.study_time = moment(item.study_date).format('DD/MM/YYYY') + ", " + item.start_hour + " - " + item.end_hour
          }
        })
      }

      this.liveUrl = this.tutoring.live_url;
      $(`#comment-modal-${this.tutoring.id}`).modal("show");

    },
    // join_class(tutoring) {
    //     const that = this;
    //     that.$store.commit("setLoading", true);
    //     joinLiveClass({
    //         id: tutoring.id
    //     }).then((response) => {
    //         that.$store.commit("setLoading", false);

    //         if (response.data.code != 0) {
    //             return;
    //         }

    //         $('#tutoringDetailJoinClassModal'+tutoring.id).modal("hide");

    //         window.open(response.data.results.link, '_blank');

    //         that.$emit('updateTutoring', 'join_class', tutoring, response.data.results);
    //     }).catch(({ response }) => {
    //         that.$store.commit("setLoading", false);
    //         console.error(response);
    //     });
    // },

    // subscribe(tutoring) {
    //     const that = this;
    //     that.$store.commit("setLoading", true);

    //     tutoringSubscribe({
    //         id: tutoring.id
    //     }).then((response) => {
    //         that.$store.commit("setLoading", false);
    //         if (response.data.results.status == 6){
    //             return false;
    //         }
    //         if (response.data.code != 0) {
    //             return;
    //         }

    //         $('#tutoringRegisterModal' + tutoring.id).modal("hide");

    //         that.$emit('updateTutoring', 'subscribe', tutoring, response.data.results);
    //     }).catch(({ response }) => {
    //         that.$store.commit("setLoading", false);

    //         console.error(response);
    //     });
    // },

    // unsubscribeVerify(tutoring) {
    //     $('#tutoringDetailCancelRegistrationModal'+tutoring.id).modal('hide');
    //     $('#tutoringDetailCancelRegistrationVerifyModal'+tutoring.id).modal();
    // },

    countdownFinished() {
      console.log('Finished....!');

      this.tutoring.status = 2;
    },
    countdownFinished2() {
      const timeCurrent = Math.floor(Date.now() / 1000);
      this.timeRemaining = Math.floor((this.tutoring.time_start -  timeCurrent) / 3600);
    },

    // unsubscribe(tutoring) {
    //     const that = this;

    //     that.$store.commit("setLoading", true);

    //     tutoringSubscribe({
    //         id: tutoring.id
    //     }).then((response) => {
    //         that.$store.commit("setLoading", false);

    //         if (response.data.code != 0) {
    //             return;
    //         }

    //         $('#tutoringDetailCancelRegistrationVerifyModal'+tutoring.id).modal('hide');

    //         that.$emit('updateTutoring', 'unsubscribe', tutoring, response.data.results);
    //     }).catch(({ response }) => {
    //         that.$store.commit("setLoading", false);

    //         console.error(response);
    //     });
    // },


  }
}
</script>

<style scoped>
.title-comment {
  color: #ff7800;
  font-size: 24px;
  font-weight: 700;
}

.content-comment {
  border: 1px solid #0000001A;
  border-radius: 5px;
  margin: 10px;
  padding: 10px;
  white-space: pre-line;
}

.content-no-comment {
  text-align: center;
  border: 1px solid #0000001A;
  border-radius: 5px;
  margin: 10px;
  padding: 50px;
  white-space: pre-line;
  font-size: 18px;
}


</style>
